import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function AchievementsSection() {
  const achievements = [{
    text: <span data-id="element-35">
          Pasarás de leer nombres abstractos a{' '}
          <span className="font-bold text-green-800 highlight-gold" data-id="element-36">
            VER los lugares reales
          </span>{' '}
          donde ocurrió cada acontecimiento bíblico
        </span>
  }, {
    text: <span data-id="element-37">
          Entenderás{' '}
          <span className="font-bold text-gray-900 underline-subtle" data-id="element-38">
            POR QUÉ
          </span>{' '}
          los eventos ocurrieron donde ocurrieron
        </span>
  }, {
    text: <span data-id="element-39">
          Alcanzarás una{' '}
          <span className="font-bold text-gray-900" data-id="element-40">
            profundidad de estudio
          </span>{' '}
          que pocos tienen. Tus devocionales, clases y sermones tendrán un{' '}
          <span className="italic font-medium text-green-800" data-id="element-41">
            nivel de detalle
          </span>{' '}
          que{' '}
          <span className="highlight-warm font-bold" data-id="element-42">
            impactará a quienes te escuchen
          </span>
          .
        </span>
  }, {
    text: <span data-id="element-43">
          Tendrás un{' '}
          <span className="font-bold text-gray-900" data-id="element-44">
            recurso de consulta inmediata
          </span>{' '}
          para toda la vida. Cada vez que leas un pasaje y quieras saber{' '}
          <span className="font-bold text-green-800" data-id="element-45">DÓNDE</span> y{' '}
          <span className="font-bold text-green-800" data-id="element-46">CÓMO</span> se veía ese
          lugar, abrirás tu Biblia Visual y{' '}
          <span className="underline-subtle font-medium" data-id="element-47">
            lo tendrás al instante
          </span>
        </span>
  }];
  return <section className="py-8 md:py-16 bg-parchment-100 border-y border-gold-200" data-id="element-48">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-49">
        <div className="text-center mb-6 md:mb-12" data-id="element-50">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-navy-900 mb-4" data-id="element-51">
            ¿Qué Lograrás Con Este Recurso?
          </h2>
          <div className="w-24 h-1 bg-green-600 mx-auto" data-id="element-52"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-6" data-id="element-53">
          {achievements.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-4 md:p-5 rounded-xl shadow-md border border-green-100 hover:shadow-lg transition-shadow duration-300" data-id="element-54">
              <div className="flex items-start" data-id="element-55">
                <CheckCircle2 className="w-5 h-5 text-green-500 mr-2 mt-1 flex-shrink-0" data-id="element-56" />
                <p className="text-gray-800 font-medium leading-relaxed" data-id="element-57">
                  {item.text}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}